exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Hwwsiz_ECvpmoGV15sPhl {\n    margin: 5px;\n}", ""]);

// exports
exports.locals = {
	"button": "_1Hwwsiz_ECvpmoGV15sPhl"
};